// ══════════════ GERANT UI — optimisé mobile ══════════════
// Extrait de GerantClientUI.jsx (refacto étape GerantUI, 08/07/2026).
// Le plus gros composant du fichier (376 lignes). Feuille confirmée par contrôle
// anti-cycle exhaustif : les 14 composants JSX référencés sont tous déjà importés
// depuis leurs vraies sources (aucun encore défini dans GerantClientUI).
// TaskCard et sa constante TT2 sont des sous-composants internes définis dans le
// corps même de GerantUI (closures), ils voyagent naturellement avec l'extraction.
// Ne référence ni StaffUI, ni ClientUI, ni les briques exclusivement terrain
// (LeaveForm, DailyPunch, AptPunch, Ic, Cani*).
import React, { useState, useEffect } from 'react';
import { today, now, fname, fd, ft, geoOk, dureeStatut } from "../utils.js";
import { TT } from "../constants.js";
import { notifEventBus } from '../notifBus.js';
import { useGeo } from "./Pointage.jsx";
import { supaGet, supaSet, supaSetStrict, syncBus } from "../supabase.js";
import { enqueue, confirmByRecordIds } from "../localQueue.js";
import { M } from "./M.jsx";
import { ErrorBoundary, RapportModal, getRapportStructure } from './ErrorBoundary.jsx';
import { SimpleChat } from './SimpleChat.jsx';
import { OTQuick } from './OTQuick.jsx';
import { GeoHelpBanner } from './GeoHelpBanner.jsx';
import { RepLibreSelector, ControleLibreSelector } from './RapportSelectors.jsx';
import { CommentaireModal, DureeSignalModal } from './RHTerrain.jsx';
import { AlerteSanteButton } from './Canicule.jsx';
import { WeekPlan } from "./TaskForm.jsx";
import { FichePrepaModal } from "./SecPrest.jsx";
import { SecControles, CtrlModal } from "./SecRapports.jsx";
import { CalendrierSejours } from "./CalendrierSejours.jsx";
import { AssistanceBanner, DureeAnomBanner } from "./GerantClientUI.jsx";

function GerantUI({sess,...P}){
  const{st,setSt,biens,staff,gerants,leave,msgs,setMsgs,rep,setRep,pj,prov,objets,setObjets,als,setAls,setAlsSynced,assist,setAssist,dureeAnom,setDureeAnom}=P;
  const me=gerants.find(g=>g.id===sess.id);
  const[tab,setTab]=useState('today');
  const[repT,setRepT]=useState(null);
  const[showOT,setShowOT]=useState(false);
  const[otConfirm,setOtConfirm]=useState(null);
  const[fichePrepa,setFichePrepa]=useState(null);
  const[showCreer,setShowCreer]=useState(false);
  const[ci,setCi]=useState(null);
  const[showRepLibre,setShowRepLibre]=useState(false);
  const[repLibreBid,setRepLibreBid]=useState('');
  const[repLibreDate,setRepLibreDate]=useState('');
  const[repLibreT,setRepLibreT]=useState(null); // bien synthétique pour RapportModal
  const[showCtrlLibre,setShowCtrlLibre]=useState(false);
  const[ctrlLibreBid,setCtrlLibreBid]=useState('');
  const[ctrlLibreRepId,setCtrlLibreRepId]=useState(null); // repId rattaché, null=orphelin
  const[ctrlLibreOpen,setCtrlLibreOpen]=useState(false);  // true=ouvrir CtrlModal
  const[ctrlLibreDirty,setCtrlLibreDirty]=useState(false);
  const closeCtrlLibre=()=>{
    if(ctrlLibreDirty&&!window.confirm('Ce contrôle a des modifications non enregistrées (photos, notes…). Fermer sans sauvegarder ?')) return;
    setCtrlLibreDirty(false);
    setCtrlLibreOpen(false);setCtrlLibreBid('');setCtrlLibreRepId(null);
  };
  const[commentT,setCommentT]=useState(null); // tâche pour modale commentaire check-in/out
  const allStaff=[...staff,{id:sess.id,name:me?.name||'Direction',role:me?.role||'Direction',_gerant:true}];
  const todayS=today();
  // ─── Création d'intervention depuis le compte direction (terrain) ───
  // Limitée au type 'intervention' ; assignation au choix, soi-même par défaut.
  const ouvrirCreer=()=>{setCi({bid:biens[0]?.id||'',sid:sess.id,date:todayS,sh:9,sm:0,dm:90,natureIntervention:'',notes:''});setShowCreer(true);};
  const creerIntervention=async()=>{
    if(!ci||!ci.bid){return;}
    // READ-BEFORE-WRITE sur st7 (cohérence multi-session, même pattern que saveTask et punch)
    let freshSt=st;
    try{const remote=await supaGet('st7');if(Array.isArray(remote))freshSt=remote;}
    catch(e){console.warn('[creerIntervention] Lecture fraiche echouee, fallback local',e.message);}
    // Whitelist IDENTIQUE a la branche staff de saveTask (toute evolution doit etre repercutee aux deux endroits)
    const task={id:'t'+Date.now(),sid:ci.sid||null,bid:ci.bid,type:'intervention',date:ci.date,sh:Number(ci.sh)||0,sm:Number(ci.sm)||0,dm:Number(ci.dm)||60,notes:ci.notes||'',alerte:'',st:'todo',prio:'normal',rs:null,re:null,surcharge25:false,risque:!ci.sid,applyTarifUrgent:false,noReport:false,dureeManuelle:null,natureIntervention:ci.natureIntervention||'',rdv:false};
    const nextSt=[...freshSt,task];
    try{await supaSet('st7',nextSt);setSt(nextSt);}
    catch(e){console.error('[creerIntervention] Ecriture st7 echouee, fallback local',e.message);setSt(ls=>[...ls,task]);}
    // notif tache_affectee uniquement si on l'assigne a quelqu'un d'autre que soi
    if(task.sid&&task.sid!==sess.id){
      const bien=biens.find(b=>b.id===task.bid);
      const heure=`${String(task.sh).padStart(2,'0')}:${String(task.sm).padStart(2,'0')}`;
      notifEventBus.emit('tache_affectee',{toUserType:'staff',toUserId:task.sid,taskId:task.id,taskType:'intervention',date:task.date,summary:`Nouvelle intervention le ${task.date} a ${heure} · ${bien?.name||'?'}`});
    }
    setShowCreer(false);setCi(null);
  };
  const myTodayT=st.filter(t=>t.sid===sess.id&&t.date===todayS);
  const myFutureT=st.filter(t=>t.sid===sess.id&&t.date>todayS).sort((a,b)=>a.date.localeCompare(b.date));
  const ur=msgs.filter(m=>m.tid===`gerant:${sess.id}`&&!m.ru).length;
  const exRep=repT?rep.find(r=>r.tid===repT.id):null;
  const saveRep=(r,fin)=>{
    // Mise à jour React locale immédiate (affichage instantané).
    setRep(prev=>{const i=prev.findIndex(x=>x.id===r.id);return i>=0?prev.map(x=>x.id===r.id?r:x):[...prev,r];});
    // ─── Read-before-write à la soumission définitive (Option B, correctif 06/09/2026) ─────
    // Miroir strict de persistRep dans StaffUI.jsx — même logique, même garde-fou.
    if(fin){
      (async()=>{
        try{
          const fresh=(await supaGet('rep7'))||[];
          const i=fresh.findIndex(x=>x.id===r.id);
          const merged=i>=0?fresh.map(x=>x.id===r.id?r:x):[...fresh,r];
          await supaSetStrict('rep7',merged);
          setRep(merged);
        }catch(e){
          console.error('[saveRep GerantUI] read-before-write soumission finale échoué (non bloquant, retry useSt en cours)',e);
        }
      })();
    }
    // ─── notif : rapport_soumis (uniquement à la soumission définitive) ───
    if(fin && r.sub){
      const bien=biens.find(b=>b.id===r.bid);
      const auteur=allStaff.find(s=>s.id===r.sid)||gerants.find(g=>g.id===r.sid);
      notifEventBus.emit('rapport_soumis',{
        reportId:r.id, taskId:r.tid, bienName:bien?.name,
        fromName:auteur?.name||fname(auteur)||'?',
        summary:`Rapport soumis pour ${bien?.name||'?'} par ${auteur?.name||fname(auteur)||'?'} (à contrôler)`
      });
    }
    if(fin)setRepT(null);
  };
  const saveComment=c=>{
    const isNew=!(P.commentaires||[]).some(x=>x.id===c.id);
    if(isNew&&c.niveau&&c.niveau!=='info'){
      const bien=biens.find(b=>b.id===c.bid);
      const niveauLabel=c.niveau==='incident'?'🔴 Incident':'⚠️ Point à noter';
      notifEventBus.emit('anomalie_signalee',{
        fromName:me?.name||'Direction',
        commentId:c.id,niveau:c.niveau,taskType:c.type,
        bienName:bien?.name,
        summary:`${niveauLabel} signalé(e) sur ${bien?.name||'?'} par ${me?.name||'Direction'}`,
        body:c.texte||''
      });
    }
    P.setCommentaires(prev=>{const i=prev.findIndex(x=>x.id===c.id);return i>=0?prev.map(x=>x.id===c.id?c:x):[...prev,c];});
    setCommentT(null);
  };
  const{req}=useGeo();
  const[ld,setLd]=useState(null);
  const gL=(tid,type)=>als.find(l=>l.tid===tid&&l.type===type);
  const isMenage=type=>['full','quick','linge','correction'].includes(type);
  // Seuils qualité (v154, révisé 11/08/2026) : décision Claire, la règle s'applique aussi
  // aux comptes Direction opérationnels quand ils font le ménage eux-mêmes depuis cette
  // interface — même mécanisme que côté salarié (PointageTerrain.jsx), dupliqué à
  // l'identique ici (deux copies de punch() préexistantes, même famille de dette que le
  // Chantier B). Depuis le 11/08/2026, envoyer le motif à la Direction débloque directement
  // la Fin (ctx.retry()) — ce n'est plus une simple escalade qui attend un déblocage manuel.
  const[dureeLockCtx,setDureeLockCtx]=useState(null); // {task,bien,sens,retry}
  const onDureeSignal=async(ctx,motif,qualiteConfirmee)=>{
    const rec={id:'da'+Date.now(),sid:sess.id,tid:ctx.task.id,bid:ctx.bien?.id||null,bienName:ctx.bien?.name||'?',type:ctx.task.type,sens:ctx.sens,motif,fromName:me?.name||'Direction',ts:now(),traite:false,traitePar:null,traiteTs:null,qualiteConfirmee:ctx.sens==='sous'?!!qualiteConfirmee:undefined};
    try{
      notifEventBus.emit('duree_signalee',{fromName:rec.fromName,bienName:rec.bienName,sens:rec.sens,motif,summary:`⏱️ ${rec.fromName} signale un empêchement — ${rec.bienName}`});
    }catch(_){/* jamais bloquant */}
    try{
      const base=await supaGet('dureeAnom7')||[];
      const merged=[...base,rec];
      await supaSet('dureeAnom7',merged);if(setDureeAnom)setDureeAnom(merged);
    }catch(e){console.error('[dureeAnom] écriture échouée :',e.message);if(setDureeAnom)setDureeAnom(ds=>[...(ds||[]),rec]);}
    // Le motif est consigné quelle que soit l'issue de l'écriture ci-dessus (best-effort,
    // même garantie que le reste de dureeAnom7) — le déblocage de la tâche, lui, ne doit
    // jamais dépendre du succès de cette écriture secondaire.
    ctx.retry&&ctx.retry();
  };
  // punch : read-before-write atomique sur als7 pour éviter les écrasements lors de collisions multi-session.
  const punch=(t,type,opts={})=>{
    // Seuils qualité (v154, révisé 11/08/2026) : garde-fou identique à PointageTerrain.jsx —
    // ouvre DureeSignalModal directement au clic plutôt que de désactiver le bouton en amont.
    if(type==='end'&&isMenage(t.type)&&!t.groupeBinome&&!opts.skipDureeCheck){
      const b0=biens.find(x=>x.id===t.bid);
      const ls0=gL(t.id,'start');
      const st0=ls0?dureeStatut(b0,t.type,(Date.now()-new Date(ls0.ts).getTime())/60000):null;
      if(st0){setDureeLockCtx({task:t,bien:b0,sens:st0,retry:()=>punch(t,'end',{skipDureeCheck:true})});return;}
    }
    // Fin déjà pointée pour cette tâche : ne PAS réécrire (anti-doublon v186), mais ROUVRIR
    // le rapport s'il n'est pas encore soumis — voir PointageTerrain.jsx pour le détail.
    // Copie Direction : pas de mode guidé, on rouvre toujours le rapport classique (setRepT),
    // à l'identique de la fin de punch (l.168). hasReport inliné car défini plus bas.
    if(type==='end'&&gL(t.id,'end')){
      setLd(null);
      if(isMenage(t.type)&&!(rep||[]).some(r=>r.tid===t.id&&r.sub))setRepT(t);
      return;
    }
    setLd(t.id+type);const b=biens.find(x=>x.id===t.bid);req(async(g,err)=>{setLd(null);const ck=g&&b?geoOk(g,b):{ok:null};const newAl={id:'a'+Date.now(),sid:sess.id,tid:t.id,bid:t.bid,type,ts:now(),geo:g||null,geoErr:err||null,ok:ck.ok,dist:ck.d};
    // Chantier B (01/08/2026) : écriture locale AVANT le réseau (principe localQueue.js
    // §"rien ne part sur le réseau avant d'avoir été écrit sur le disque"). Si tout ce qui
    // suit meurt (app en arrière-plan pendant l'appel), le rejeu silencieux au prochain
    // démarrage (queueAutoReplay.js) retrouve ce pointage — indépendamment du sort du
    // retry ci-dessous, qui reste utile pour la reprise rapide si l'app survit.
    await enqueue({key:'als7',recordId:newAl.id,payload:newAl,sid:sess.id,authorLabel:sess.name||'',fin:true});
    try{const base=await supaGet('als7')||[];const merged=[...base.filter(x=>x.id!==newAl.id),newAl];await supaSet('als7',merged);setAlsSynced(merged);confirmByRecordIds('als7',[newAl.id]);}catch(e){console.error('[punch] Écriture als7 échouée, retry en cours :',e.message);setAlsSynced([...als,newAl]);syncBus.dispatchEvent(new CustomEvent('error',{detail:{key:'als7',message:e.message,attempt:1,op:'write'}}));const _punchRetry=(attempt)=>{const delay=Math.min(2000*Math.pow(2,attempt-1),30000);setTimeout(async()=>{try{const base2=await supaGet('als7')||[];const merged2=[...base2.filter(x=>x.id!==newAl.id),newAl];await supaSet('als7',merged2);setAlsSynced(merged2);confirmByRecordIds('als7',[newAl.id]);syncBus.dispatchEvent(new CustomEvent('ok',{detail:{key:'als7'}}));}catch(e2){console.error('[punch] Retry',attempt,'échoué :',e2.message);syncBus.dispatchEvent(new CustomEvent('error',{detail:{key:'als7',message:e2.message,attempt:attempt+1,op:'write'}}));_punchRetry(attempt+1);}},delay);};_punchRetry(1);}if(type==='end'&&isMenage(t.type)){
    // ─── notif : menage_termine (vers admin/direction) ───
    notifEventBus.emit('menage_termine',{
      taskId:t.id, taskType:t.type, bienName:b?.name,
      fromName:me?.name||'Direction',
      summary:`Ménage terminé à ${b?.name||'?'} par ${me?.name||'Direction'}`
    });
    setRepT(t);
  }else if(type==='end')setCommentT(t);});};
  // Détection rapports en attente : ménages du jour avec pointage end mais sans rapport soumis (sub=null)
  // Exclut les tâches noReport (rapport rendu optionnel par admin pour ce ménage précis)
  const hasReport=tid=>(rep||[]).some(r=>r.tid===tid&&r.sub);
  const pendingTasks=myTodayT.filter(t=>isMenage(t.type)&&!t.noReport&&gL(t.id,'end')&&!hasReport(t.id));
  const hasPending=pendingTasks.length>0;

  // Composant carte intervention mobile
  const TaskCard=({t,showDate})=>{
    const b=biens.find(x=>x.id===t.bid);
    const r=rep.find(x=>x.tid===t.id);
    const TT2={full:{e:'🧹',l:'Ménage complet',c:'#2d6b3e',bg:'#e1f0e5'},checkin:{e:'🔑',l:'Check-in',c:'#b85d10',bg:'#ffe9d6'},checkout:{e:'🚪',l:'Check-out',c:'#1a5fa0',bg:'#dbeeff'},quick:{e:'⚡',l:'Passage rapide',c:'#7a5a00',bg:'#fff4d6'},linge:{e:'👕',l:'Linge',c:'#5a2d82',bg:'#f0e6ff'},intervention:{e:'🔧',l:'Intervention',c:'#0c5a82',bg:'#e0f2fe'},gardeCheckin:{e:'📋',l:'Garde check-in',c:'#4338ca',bg:'#e0e7ff'},gardeBoutique:{e:'🏪',l:'Boutique',c:'#b45309',bg:'#fef3c7'}};
    const tt=TT2[t.type]||{e:'📋',l:t.type,c:'var(--si)',bg:'var(--bg)'};
    // Pointages de cette tâche
    const ls=gL(t.id,'start'),le=gL(t.id,'end');
    const menage=isMenage(t.type);
    // URL Google Maps pour l'itinéraire
    const mapDest=b?.lat&&b?.lng?`${b.lat},${b.lng}`:[b?.addr,b?.zip,b?.city].filter(Boolean).join(' ');
    const mapUrl=mapDest?`https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(mapDest)}&travelmode=driving`:null;
    return(<div className="card" style={{padding:'14px 16px',borderLeft:`4px solid ${tt.c}`,marginBottom:10}}>
      <div style={{display:'flex',justifyContent:'space-between',alignItems:'flex-start',gap:10}}>
        <div style={{flex:1}}>
          {showDate&&<div style={{fontSize:11,fontWeight:700,color:'var(--si)',marginBottom:4,textTransform:'uppercase',letterSpacing:'.05em'}}>{fd(t.date)}</div>}
          <div className="D" style={{fontSize:17,marginBottom:3}}>{b?.name||tt.l}</div>
          <div style={{display:'flex',gap:6,alignItems:'center',flexWrap:'wrap',marginBottom:6}}>
            <span style={{background:tt.bg,color:tt.c,fontSize:12,fontWeight:700,padding:'3px 9px',borderRadius:999}}>{tt.e} {tt.l}</span>
            <span style={{fontSize:12,color:'var(--si)'}}>{String(t.sh).padStart(2,'0')}:{String(t.sm).padStart(2,'0')} · {t.dm}min</span>
          </div>
          {b?.addr&&<div style={{fontSize:11,color:'var(--si)'}}>{b.addr}</div>}
          {t.type==='intervention'&&t.natureIntervention&&<div style={{fontSize:12,fontStyle:'italic',color:'#0c5a82',marginTop:4}}>🔧 {t.natureIntervention}</div>}
          {(ls||le)&&<div style={{display:'flex',gap:10,fontSize:11,marginTop:6}}>{ls&&<span style={{color:'var(--ok)',fontWeight:600}}>▶ {ft(ls.ts)}{ls.ok===false?' ⚠':''}</span>}{le&&<span style={{color:'var(--dg)',fontWeight:600}}>⏹ {ft(le.ts)}{le.ok===false?' ⚠':''}</span>}</div>}
        </div>
        <div style={{display:'flex',flexDirection:'column',gap:6,alignItems:'flex-end'}}>
          {/* Bouton pointage : Début → Fin → Terminé */}
          {!ls
            ?<button onClick={()=>punch(t,'start')} className="btn bmn sm" disabled={ld===t.id+'start'||hasPending} title={hasPending?'Termine d\'abord le rapport en attente':''} style={hasPending?{fontSize:12,padding:'8px 14px',opacity:.4,cursor:'not-allowed'}:{fontSize:12,padding:'8px 14px'}}>▶ Début</button>
            :!le
              // Bloquer Fin si un autre ménage a son rapport en attente (mais pas si c'est la même tâche).
              // Le seuil qualité (v154) ne désactive plus le bouton : punch() gère l'ouverture
              // de la modale lui-même au clic si la tâche est hors fourchette.
              ?(()=>{const blockEnd=hasPending&&!pendingTasks.some(p=>p.id===t.id);
                return(<button onClick={()=>punch(t,'end')} className="btn bor sm" disabled={ld===t.id+'end'||blockEnd} title={blockEnd?'Termine d\'abord le rapport en attente sur un autre appart':''} style={blockEnd?{fontSize:12,padding:'8px 14px',opacity:.4,cursor:'not-allowed'}:{fontSize:12,padding:'8px 14px'}}>⏹ {menage&&!t.noReport?'Fin+Rapport':'Fin'}</button>);
              })()
              :menage&&!r?.sub&&!t.noReport
                ?<span className="pill" style={{fontSize:11,background:'#fff4d6',color:'#7a5a00',border:'1.5px solid #e5c977'}}>📝 Rapport en attente</span>
                :<span className="pill pok" style={{fontSize:11}}>✓ Terminé</span>
          }
          {/* Rapport (uniquement pour les ménages) — disponible dès le pointage de début (en brouillon) */}
          {menage&&(r?.sub
            ?<span className="pill pok" style={{fontSize:11}}>✅ Rapport fait</span>
            :ls&&<div style={{display:'flex',flexDirection:'column',alignItems:'flex-end',gap:1}}>
              <button onClick={()=>setRepT(t)} className="btn bgh sm" style={{fontSize:11,padding:'6px 10px'}} title={t.noReport?'Rapport optionnel pour cette tâche — tu peux le remplir si tu le souhaites':(le?'Soumettre le rapport (obligatoire avant un autre pointage)':'Remplir le rapport au fur et à mesure (sauvegardé en brouillon)')}>📝 Rapport</button>
              {t.noReport&&<span style={{fontSize:9,color:'var(--si)',fontStyle:'italic'}}>optionnel</span>}
            </div>
          )}
          {/* Itinéraire et fiche prépa */}
          {mapUrl&&!le&&<a href={mapUrl} target="_blank" rel="noopener noreferrer" className="btn bgh sm" style={{fontSize:11,padding:'6px 10px',textDecoration:'none'}}>🗺️ Itinéraire</a>}
          {menage&&<button onClick={()=>setFichePrepa(b)} className="btn bgh sm" style={{fontSize:11}}>📋 Fiche</button>}
          {le&&!menage&&<button onClick={()=>setCommentT(t)} className="btn bgh sm" style={{fontSize:11}}>💬</button>}
        </div>
      </div>
    </div>);
  };

  const ctrlEnAttente=(P.rep||[]).filter(r=>r.sub&&!(P.controles||[]).some(c=>c.repId===r.id&&(c.verdict==='pret'||c.verdict==='nonpret'))).length;

  return(<div style={{paddingBottom:90}}>
    <AssistanceBanner assist={assist} setAssist={setAssist} staff={staff} gerants={gerants} sess={sess}/>
    <DureeAnomBanner dureeAnom={dureeAnom} setDureeAnom={setDureeAnom} staff={staff} gerants={gerants} sess={sess} als={als} rep={P.rep||rep} controles={P.controles}/>
    {/* Header */}
    <div style={{background:'linear-gradient(135deg,#1a5fa0,#4a9eff)',borderRadius:16,padding:'18px 20px',marginBottom:18,color:'white'}}>
      <div className="D" style={{fontSize:26,marginBottom:2}}>Bonjour {me?.name} 👋</div>
      <div style={{fontSize:12,opacity:.85}}>{me?.role} · La Conciergerie</div>
      <div style={{marginTop:10,display:'flex',gap:8,flexWrap:'wrap'}}>
        <span style={{background:'rgba(255,255,255,.2)',borderRadius:999,padding:'4px 12px',fontSize:12,fontWeight:600}}>
          📅 {myTodayT.length} intervention{myTodayT.length>1?'s':''} aujourd'hui
        </span>
        {myFutureT.length>0&&<span style={{background:'rgba(255,255,255,.2)',borderRadius:999,padding:'4px 12px',fontSize:12,fontWeight:600}}>
          🔜 {myFutureT.length} à venir
        </span>}
      </div>
    </div>
    <AlerteSanteButton sid={sess.id} nom={me?.name} role={me?.role} liftForNav/>

    {/* ── Bandeau feedback contrôle qualité v2 (même logique que StaffUI) ── */}
    {(()=>{
      const feedbacks=((P.controles||[]).filter(c=>
        c.version===2&&
        !c.feedbackVu?.[sess.id]&&
        (c.verdict==='pret'||c.verdict==='nonpret')&&
        (rep||[]).some(r=>(c.repId?r.id===c.repId:r.bid===c.bid&&r.date===c.date)&&r.sid===sess.id)
      ));
      if(feedbacks.length===0)return null;
      return(<div style={{display:'flex',flexDirection:'column',gap:6,marginBottom:16}}>
        {feedbacks.map(c=>{
          const bien=(biens||[]).find(b=>b.id===c.bid);
          const nc=c.nonConformites||0;
          const tot=c.totalItemsRapport||0;
          const scoreNs=Object.values(c.pieces||{}).map(p=>p?.note).filter(Boolean);
          const avg=scoreNs.length?(scoreNs.reduce((s,n)=>s+n,0)/scoreNs.length).toFixed(1):null;
          const dateLabel=c.closedAt?new Date(c.closedAt).toLocaleDateString('fr-FR',{day:'2-digit',month:'2-digit'}):'';
          const hasProblems=nc>0||(avg&&parseFloat(avg)<3);
          return(<div key={c.id} style={{background:hasProblems?'#fde0e0':'#e1f7ee',border:`1.5px solid ${hasProblems?'var(--dg)':'var(--mn)'}`,borderRadius:10,padding:'10px 13px',cursor:'pointer'}} onClick={async()=>{
            const items=Object.entries(c.items||{}).filter(([_,v])=>v.ok===false);
            const struct=bien?getRapportStructure(bien):null;
            const allItems=struct?.items||[];
            const detail=items.length>0
              ?items.map(([id,v])=>{
                const found=allItems.find(it=>it.id===id);
                const lb=found?.lb||found?.l||id;
                return`\u2022 ${lb}${v.obs?' \u2014 '+v.obs:''}`;
              }).join('\n')
              :'Aucun point relev\u00e9.';
            window.alert(`Contr\u00f4le du ${dateLabel} \u2014 ${bien?.name||'?'}\n\nNote : ${avg||'\u2014'}/4\nNon-conformit\u00e9s : ${nc} / ${tot}\n\n${detail}`);
            try{
              const base=await supaGet('controles7')||[];
              const updated=base.map(x=>x.id===c.id?{...x,feedbackVu:{...(x.feedbackVu||{}),[sess.id]:true}}:x);
              await supaSet('controles7',updated);
              P.setControles&&P.setControles(prev=>prev.map(x=>x.id===c.id?{...x,feedbackVu:{...(x.feedbackVu||{}),[sess.id]:true}}:x));
            }catch(e){console.error('[feedback] feedbackVu \u00e9chou\u00e9',e);}
          }}>
            <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',gap:8}}>
              <div style={{flex:1}}>
                <div style={{fontSize:12.5,fontWeight:700,color:hasProblems?'var(--dg)':'var(--ok)'}}>{hasProblems?'\u26A0\uFE0F':'\u2705'} Contr{'\u00f4'}le du {dateLabel} {'\u2014'} {bien?.name||'?'}</div>
                <div style={{fontSize:11,color:'var(--si)',marginTop:2}}>{nc} non-conformit{'\u00e9'}{nc>1?'s':''}{avg?` \u00B7 Note ${avg}/4`:''}</div>
              </div>
              <span style={{fontSize:11,color:'var(--si)',flexShrink:0}}>{'Voir \u2192'}</span>
            </div>
          </div>);
        })}
      </div>);
    })()}

    {/* Contenu selon onglet */}
    {tab==='today'&&(<div>
      <GeoHelpBanner sid={sess.id} tc={P.tc||[]} als={als}/>
      {hasPending&&(
        <div style={{background:'#fff4d6',border:'2px solid #e5c977',borderRadius:12,padding:'14px 18px',marginBottom:14,display:'flex',gap:14,alignItems:'flex-start',flexWrap:'wrap'}}>
          <div style={{fontSize:32,lineHeight:1}}>📝</div>
          <div style={{flex:1,minWidth:240}}>
            <div className="D" style={{fontSize:15,color:'#7a5a00',marginBottom:4}}>{pendingTasks.length===1?'Rapport en attente':`${pendingTasks.length} rapports en attente`}</div>
            <div style={{fontSize:12,color:'#7a5a00',lineHeight:1.5}}>
              Tu dois <strong>soumettre le rapport de fin de ménage</strong> avant de pouvoir commencer une autre intervention :
              <ul style={{margin:'6px 0 0 18px',padding:0,lineHeight:1.6}}>
                {pendingTasks.map(t=>{const b=biens.find(x=>x.id===t.bid);return(<li key={t.id}><strong>{b?.name||'?'}</strong> — clique sur le bouton orange <em>📝 Rapport</em> sur cet appartement.</li>);})}
              </ul>
            </div>
          </div>
        </div>
      )}
      <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:12}}>
        <div className="D" style={{fontSize:18}}>Aujourd'hui</div>
        <div style={{display:'flex',gap:6,flexWrap:'wrap'}}>
          <button onClick={ouvrirCreer} className="btn bor sm" style={{fontSize:12}}>🔧 Créer une intervention</button>
          <button onClick={()=>{setRepLibreBid(biens[0]?.id||'');setRepLibreDate(todayS);setRepLibreT(null);setShowRepLibre(true);}} className="btn bgh sm" style={{fontSize:12}}>🧹 Rapport libre</button>
          <button onClick={()=>{setCtrlLibreBid(biens[0]?.id||'');setCtrlLibreRepId(null);setCtrlLibreOpen(false);setShowCtrlLibre(true);}} className="btn bgh sm" style={{fontSize:12}}>🔍 Contrôle libre</button>
        </div>
      </div>
      {myTodayT.length===0
        ?<div style={{textAlign:'center',padding:'40px 20px',color:'var(--si)'}}>
            <div style={{fontSize:40,marginBottom:10}}>☀️</div>
            <div style={{fontWeight:600}}>Aucune intervention aujourd'hui</div>
          </div>
        :myTodayT.sort((a,b)=>a.sh-b.sh||a.sm-b.sm).map(t=><TaskCard key={t.id} t={t} showDate={false}/>)
      }
      {myFutureT.length>0&&(<div style={{marginTop:20}}>
        <div className="D" style={{fontSize:16,marginBottom:10,color:'var(--si)'}}>Prochaines interventions</div>
        {myFutureT.slice(0,3).map(t=><TaskCard key={t.id} t={t} showDate={true}/>)}
        {myFutureT.length>3&&<div style={{textAlign:'center',marginTop:8}}><button onClick={()=>setTab('plan')} className="btn bgh sm">Voir tout le planning →</button></div>}
      </div>)}
    </div>)}

    {tab==='plan'&&(<div>
      <div className="D" style={{fontSize:18,marginBottom:12}}>Mon planning</div>
      <div style={{overflowX:'auto'}}>
        <WeekPlan st={st} pj={pj} staff={allStaff} prov={prov} biens={biens} leave={leave} arretsMaladie={(P.arretsMaladie||[]).filter(a=>a.sid===sess.id)} unavail={P.unavail} als={als} rep={rep} scopeS={sess.id}/>
      </div>
    </div>)}

    {/* Onglet SÉJOURS — vue occupation mensuelle. Volontairement distinct de « Planning »
        (WeekPlan = tâches/semaine). Ne pas fusionner les deux : ce sont deux métiers. */}
    {tab==='sej'&&(<div>
      <div className="D" style={{fontSize:18,marginBottom:12}}>Calendrier des séjours</div>
      <CalendrierSejours biens={biens} sejours={P.sejours||[]} clients={P.clients||[]}/>
    </div>)}

    {tab==='ctrl'&&(<div style={{paddingBottom:8}}>
      <div style={{display:'flex',gap:8,marginBottom:16,flexWrap:'wrap'}}>
        <button onClick={()=>{setRepLibreBid(biens[0]?.id||'');setRepLibreDate(today());setRepLibreT(null);setShowRepLibre(true);}} className="btn bgh sm" style={{fontSize:12}}>🧹 Rapport libre</button>
        <button onClick={()=>{setCtrlLibreBid(biens[0]?.id||'');setCtrlLibreRepId(null);setCtrlLibreOpen(false);setShowCtrlLibre(true);}} className="btn bgh sm" style={{fontSize:12}}>🔍 Controle libre</button>
      </div>
      <SecControles controles={P.controles||[]} setControles={P.setControles} rep={rep} setRep={setRep} biens={biens} staff={staff} gerants={gerants} sess={sess} als={als} dureeAnom={dureeAnom}/>
    </div>)}
    {tab==='prep'&&(<div>
      <div className="D" style={{fontSize:18,marginBottom:4}}>Fiches de préparation</div>
      <div style={{fontSize:12,color:'var(--si)',marginBottom:14}}>Appuyez sur un appartement pour voir sa fiche.</div>
      <div style={{display:'flex',flexDirection:'column',gap:10}}>
        {biens.map(b=>{
          const pr=b.prep||{};
          const hasPrep=[pr.draps,pr.draps1p,pr.housses,pr.housses1p,pr.taies,pr.nespresso,pr.bretzels,pr.kitAccueilPrep,pr.packBienvenuePrep,pr.savonnettes,pr.shampooing,pr.gelDouche,pr.serviettes2p,pr.serviettes1p,...(pr.extras||[])].some(v=>v&&v!==0);
          return(<div key={b.id} className="card" style={{padding:'16px',borderLeft:'4px solid var(--bl)',cursor:'pointer',display:'flex',justifyContent:'space-between',alignItems:'center'}} onClick={()=>setFichePrepa(b)}>
            <div>
              <div className="D" style={{fontSize:16,marginBottom:2}}>{b.name}</div>
              <div style={{fontSize:11,color:'var(--si)',marginBottom:6}}>{b.addr}</div>
              {hasPrep?(<div style={{display:'flex',flexWrap:'wrap',gap:4}}>
                {(pr.draps||0)>0&&<span style={{background:'#e1f7ee',color:'#2d6b3e',fontSize:10,fontWeight:600,padding:'2px 7px',borderRadius:999}}>🛏 {pr.draps} draps</span>}
                {(pr.housses||0)>0&&<span style={{background:'#e1f7ee',color:'#2d6b3e',fontSize:10,fontWeight:600,padding:'2px 7px',borderRadius:999}}>🛌 {pr.housses} housses</span>}
                {(pr.nespresso||0)>0&&<span style={{background:'#fff4d6',color:'#7a5a00',fontSize:10,fontWeight:600,padding:'2px 7px',borderRadius:999}}>☕ {pr.nespresso} capsules</span>}
                {pr.bretzels&&<span style={{background:'#fff4d6',color:'#7a5a00',fontSize:10,fontWeight:600,padding:'2px 7px',borderRadius:999}}>🥨 Bretzels</span>}
              </div>):(<div style={{fontSize:11,color:'var(--si)',fontStyle:'italic'}}>Fiche non configurée</div>)}
            </div>
            <div style={{fontSize:22,marginLeft:10}}>›</div>
          </div>);
        })}
      </div>
      {fichePrepa&&<M onC={()=>setFichePrepa(null)} title={`📋 ${fichePrepa.name}`} col="var(--bl)" ch={<FichePrepaModal bien={fichePrepa} onClose={()=>setFichePrepa(null)}/>}/>}
    </div>)}

    {tab==='msg'&&<SimpleChat sess={sess} msgs={msgs} setMsgs={setMsgs} accent="var(--bl)"/>}

    {/* Nav fixe en bas — style appli mobile */}
    <div style={{position:'fixed',bottom:0,left:0,right:0,zIndex:50,background:'white',borderTop:'1px solid var(--li)',boxShadow:'0 -4px 20px rgba(42,37,32,.08)',display:'flex',justifyContent:'space-around',alignItems:'stretch',padding:'0'}}>
      {[
        {id:'today',e:'📅',l:"Jour"},
        {id:'plan', e:'🗓',l:'Planning'},
        {id:'sej',  e:'📆',l:'Séjours'},
        {id:'ctrl', e:'🔍',l:'Controles',badge:ctrlEnAttente},
        {id:'prep', e:'📋',l:'Fiches'},
        {id:'msg',  e:'💬',l:`Messagerie${ur>0?` (${ur})`:''}`,badge:ur},
      ].map(({id,e,l,badge})=>(
        <button key={id} onClick={()=>setTab(id)} style={{flex:1,display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',padding:'10px 4px',border:'none',background:'none',cursor:'pointer',fontFamily:'Montserrat,sans-serif',position:'relative',borderTop:`3px solid ${tab===id?'var(--bl)':'transparent'}`,transition:'border .15s'}}>
          <span style={{fontSize:20,marginBottom:2}}>{e}</span>
          <span style={{fontSize:10,fontWeight:600,color:tab===id?'var(--bl)':'var(--si)',whiteSpace:'nowrap'}}>{id==='msg'?'Messagerie':l}</span>
          {badge>0&&<span style={{position:'absolute',top:6,right:'calc(50% - 18px)',background:'var(--dg)',color:'white',fontSize:9,fontWeight:700,padding:'1px 5px',borderRadius:999,minWidth:16,textAlign:'center'}}>{badge}</span>}
        </button>
      ))}
      <button onClick={()=>setShowOT(true)} style={{flex:1,display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',padding:'10px 4px',border:'none',background:'none',cursor:'pointer',fontFamily:'Montserrat,sans-serif',borderTop:'3px solid transparent'}}>
        <span style={{fontSize:20,marginBottom:2}}>📦</span>
        <span style={{fontSize:10,fontWeight:600,color:'var(--or)'}}>Objet</span>
      </button>
    </div>


    {/* ─── Rapport de ménage libre — sélecteur bien/date ─── */}
    {showRepLibre&&<RepLibreSelector
      biens={biens} st={st} rep={rep}
      bid={repLibreBid} setBid={setRepLibreBid}
      date={repLibreDate} setDate={setRepLibreDate}
      onConfirm={fakeTache=>{setRepLibreT(fakeTache);setShowRepLibre(false);}}
      onClose={()=>setShowRepLibre(false)}
    />}
    {repLibreT!==null&&(<M onC={()=>setRepLibreT(null)} title="🧹 Rapport de ménage" col="var(--or)" wide ch={
      <ErrorBoundary onClose={()=>setRepLibreT(null)}>
        <RapportModal
          task={repLibreT.id?repLibreT:null}
          bien={biens.find(b=>b.id===repLibreT.bid)||{id:repLibreT.bid}}
          sid={sess.id}
          existing={repLibreT.id?rep.find(r=>r.tid===repLibreT.id):null}
          onSave={saveRep}
          onClose={()=>setRepLibreT(null)}
        />
      </ErrorBoundary>
    }/>)}

    {/* ─── Contrôle libre — sélecteur puis vrai CtrlModal ─── */}
    {showCtrlLibre&&<ControleLibreSelector
      biens={biens} rep={rep}
      bid={ctrlLibreBid} setBid={setCtrlLibreBid}
      onConfirm={(bid,repId)=>{setCtrlLibreBid(bid);setCtrlLibreRepId(repId);setCtrlLibreOpen(true);setShowCtrlLibre(false);}}
      onClose={()=>setShowCtrlLibre(false)}
    />}
    {ctrlLibreOpen&&ctrlLibreBid&&(<M
      onC={closeCtrlLibre}
      title="🔍 Contrôle appartement" col="var(--mn)" wide
      ch={<CtrlModal
        key={ctrlLibreRepId||ctrlLibreBid}
        repId={ctrlLibreRepId}
        bien={biens.find(b=>b.id===ctrlLibreBid)}
        controleurs={[...staff,...(gerants||[])]}
        existing={null}
        onSave={(ctrl,close)=>{
          P.setControles(prev=>[...(prev||[]),ctrl]);
          if(close){setCtrlLibreDirty(false);setCtrlLibreOpen(false);setCtrlLibreBid('');setCtrlLibreRepId(null);}
        }}
        onClose={closeCtrlLibre}
        onDirtyChange={setCtrlLibreDirty}
        sess={sess}
      />}
    />)}
    {/* Modales */}
    {repT&&<M onC={()=>setRepT(null)} title="Rapport de fin de ménage" col="var(--or)" wide ch={<ErrorBoundary onClose={()=>setRepT(null)}><RapportModal task={repT} bien={biens.find(b=>b.id===repT.bid)} sid={sess.id} existing={exRep} onSave={saveRep} onClose={()=>setRepT(null)}/></ErrorBoundary>}/>}
    {commentT&&<M onC={()=>setCommentT(null)} title={`💬 Commentaire · ${TT[commentT.type]?.l||''}`} col="var(--bl)" ch={<CommentaireModal task={commentT} bien={biens.find(b=>b.id===commentT.bid)} sid={sess.id} staff={allStaff} existing={P.commentaires?.find(c=>c.tid===commentT.id)} onSave={saveComment} onClose={()=>setCommentT(null)}/>}/>}
    {dureeLockCtx&&<M onC={()=>setDureeLockCtx(null)} title={`⏱️ Empêchement · ${dureeLockCtx.bien?.name||''}`} col="var(--or)" ch={<DureeSignalModal bien={dureeLockCtx.bien} sens={dureeLockCtx.sens} isStaff={false} onSend={(motif,qualiteConfirmee)=>onDureeSignal(dureeLockCtx,motif,qualiteConfirmee)} onClose={()=>setDureeLockCtx(null)}/>}/>}
    {fichePrepa&&tab!=='prep'&&<M onC={()=>setFichePrepa(null)} title={`📋 ${fichePrepa.name}`} col="var(--bl)" ch={<FichePrepaModal bien={fichePrepa} onClose={()=>setFichePrepa(null)}/>}/>}
    {showOT&&<M onC={()=>setShowOT(false)} title="📦 Déclarer un objet trouvé" col="var(--or)"
      ch={<OTQuick biens={biens} objets={P.objets||[]} setObjets={P.setObjets} otBacs={P.otBacs||[]} setOtBacs={P.setOtBacs} sejours={P.sejours||[]} statutAppts={P.statutAppts||{}} onClose={()=>{setShowOT(false);}}/>}/>}
    {otConfirm&&<M onC={()=>setOtConfirm(null)} title="Objet enregistré ✓" col="var(--ok)" ch={<div style={{textAlign:'center',padding:'8px 0'}}>
      <div style={{fontSize:48,marginBottom:12}}>📦</div>
      <div className="D" style={{fontSize:20,marginBottom:6,color:'var(--ok)'}}>Merci !</div>
      <div style={{fontSize:13,color:'var(--si)',marginBottom:16}}>L'objet a bien été enregistré dans le registre.</div>
      <div style={{background:'var(--cr)',borderRadius:12,padding:'14px',marginBottom:12}}>
        <div style={{fontSize:11,color:'var(--si)',marginBottom:4}}>Référence</div>
        <div className="D" style={{fontSize:22,color:'var(--or)'}}>{otConfirm.ref}</div>
        {otConfirm.casier&&<div style={{marginTop:8,fontSize:13,fontWeight:700}}>Ranger dans le <span style={{color:'var(--or)'}}>Casier {otConfirm.casier}</span></div>}
      </div>
      <button onClick={()=>setOtConfirm(null)} className="btn bor" style={{marginTop:16,width:'100%'}}>Fermer</button>
    </div>}/>}
    {showCreer&&ci&&<M onC={()=>{setShowCreer(false);setCi(null);}} title="🔧 Créer une intervention" col="var(--bl)" ch={(()=>{
      const bSel=biens.find(b=>b.id===ci.bid);
      const tH=Number(bSel?.tarifInterventionH)||0;
      return(<div style={{display:'flex',flexDirection:'column',gap:12}}>
        <div>
          <label style={{fontSize:12,fontWeight:600,display:'block',marginBottom:4}}>Appartement</label>
          <select value={ci.bid} onChange={e=>setCi({...ci,bid:e.target.value})} className="inp" style={{width:'100%'}}>
            {biens.map(b=><option key={b.id} value={b.id}>{b.name}</option>)}
          </select>
          {tH>0
            ?<div style={{fontSize:11,color:'var(--si)',marginTop:4}}>Tarif intervention : <strong>{tH} €/h</strong> (facturation au quart d'heure, 1h minimum)</div>
            :<div style={{fontSize:11,color:'var(--dg)',marginTop:4}}>⚠ Aucun tarif d'intervention défini pour ce bien (à renseigner dans la fiche du bien côté admin)</div>}
        </div>
        <div>
          <label style={{fontSize:12,fontWeight:600,display:'block',marginBottom:4}}>Assignée à</label>
          <select value={ci.sid||''} onChange={e=>setCi({...ci,sid:e.target.value||null})} className="inp" style={{width:'100%'}}>
            {allStaff.map(s=><option key={s.id} value={s.id}>{s.name||fname(s)}{s.id===sess.id?' (moi)':''}</option>)}
            <option value="">Non assignée</option>
          </select>
        </div>
        <div style={{display:'flex',gap:8}}>
          <div style={{flex:2}}>
            <label style={{fontSize:12,fontWeight:600,display:'block',marginBottom:4}}>Date</label>
            <input type="date" value={ci.date} onChange={e=>setCi({...ci,date:e.target.value})} className="inp" style={{width:'100%'}}/>
          </div>
          <div style={{flex:1}}>
            <label style={{fontSize:12,fontWeight:600,display:'block',marginBottom:4}}>Heure</label>
            <input type="time" value={`${String(ci.sh).padStart(2,'0')}:${String(ci.sm).padStart(2,'0')}`} onChange={e=>{const[h,m]=e.target.value.split(':');setCi({...ci,sh:Number(h)||0,sm:Number(m)||0});}} className="inp" style={{width:'100%'}}/>
          </div>
        </div>
        <div>
          <label style={{fontSize:12,fontWeight:600,display:'block',marginBottom:4}}>Nature de l'intervention <span style={{fontWeight:400,color:'var(--si)'}}>(libellé facture)</span></label>
          <input type="text" value={ci.natureIntervention} onChange={e=>setCi({...ci,natureIntervention:e.target.value})} placeholder="ex: Remplacement ampoule + attente plombier" className="inp" style={{width:'100%'}}/>
        </div>
        <div>
          <label style={{fontSize:12,fontWeight:600,display:'block',marginBottom:4}}>Notes internes <span style={{fontWeight:400,color:'var(--si)'}}>(optionnel)</span></label>
          <textarea value={ci.notes} onChange={e=>setCi({...ci,notes:e.target.value})} className="inp" rows={2} style={{width:'100%',resize:'vertical'}}/>
        </div>
        <button onClick={creerIntervention} disabled={!ci.bid} className="btn bor" style={{width:'100%',marginTop:4}}>Créer l'intervention</button>
      </div>);
    })()}/>}
  </div>);
}

export { GerantUI };
